module.exports = __webpack_public_path__ + "static/media/concrete.44e11fda.png";